import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  default as VARIABLES
} from './../../../themes/styles/bases/variables'
import {
  TextBaseWrapper
} from './styled'

export class TextBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      top,
      left,
      fontStyle,
      width,
      color,
      hoverColor,
      align,
      verticalAlign,
      ellipsis,
      singleLine,
      // Responsive
      fontStyleMobileSm,
      fontStyleMobileMd,
      fontStyleMobileLg,
      fontStylePhabletSm,
      fontStylePhabletMd,
      fontStylePhabletLg,
      fontStyleTabletSm,
      fontStyleTabletMd,
      fontStyleTabletLg,
      // Breakpoint
      breakpointFontStyleMobileSm,
      breakpointFontStyleMobileMd,
      breakpointFontStyleMobileLg,
      breakpointFontStylePhabletSm,
      breakpointFontStylePhabletMd,
      breakpointFontStylePhabletLg,
      breakpointFontStyleTabletSm,
      breakpointFontStyleTabletMd,
      breakpointFontStyleTabletLg,
      title,
      href,
      target,
      onClick,
      inline,
      whiteSpace,
    } = this.props

    return (
      <TextBaseWrapper
        className={ClassNames(
          'text-base',
          { 'is-ellipsis': ellipsis },
          { 'is-single-line': singleLine },
          { 'is-cursor-pointer': onClick },
          { 'is-inline': inline },
          // Option
          className
        )}
        theme={{
          // Default
          top,
          left,
          fontStyle,
          width,
          color,
          hoverColor,
          align,
          verticalAlign,
          // Responsive
          fontStyleMobileSm,
          fontStyleMobileMd,
          fontStyleMobileLg,
          fontStylePhabletSm,
          fontStylePhabletMd,
          fontStylePhabletLg,
          fontStyleTabletSm,
          fontStyleTabletMd,
          fontStyleTabletLg,
          // Breakpoint
          breakpointFontStyleMobileSm,
          breakpointFontStyleMobileMd,
          breakpointFontStyleMobileLg,
          breakpointFontStylePhabletSm,
          breakpointFontStylePhabletMd,
          breakpointFontStylePhabletLg,
          breakpointFontStyleTabletSm,
          breakpointFontStyleTabletMd,
          breakpointFontStyleTabletLg,

          // WhiteSpace
          whiteSpace
        }}
        title={title}
        href={href}
        target={target}
        onClick={onClick}
      >
        {children}
      </TextBaseWrapper>
    )
  }

  static defaultProps = {
    verticalAlign: 'baseline',
    breakpointFontStyleMobileSm: VARIABLES.BREAKPOINTS.BP_359,
    breakpointFontStyleMobileMd: VARIABLES.BREAKPOINTS.BP_360,
    breakpointFontStyleMobileLg: VARIABLES.BREAKPOINTS.BP_414,
    breakpointFontStylePhabletSm: VARIABLES.BREAKPOINTS.BP_480,
    breakpointFontStylePhabletMd: VARIABLES.BREAKPOINTS.BP_640,
    breakpointFontStylePhabletLg: VARIABLES.BREAKPOINTS.BP_736,
    breakpointFontStyleTabletSm: VARIABLES.BREAKPOINTS.BP_768,
    breakpointFontStyleTabletMd: VARIABLES.BREAKPOINTS.BP_812,
    breakpointFontStyleTabletLg: VARIABLES.BREAKPOINTS.BP_1024
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string,
    top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fontStyle: PropTypes.any,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string,
    hoverColor: PropTypes.string,
    align: PropTypes.string,
    verticalAlign: PropTypes.string,
    ellipsis: PropTypes.bool,
    singleLine: PropTypes.bool,
    // Responsive
    fontStyleMobileSm: PropTypes.string,
    fontStyleMobileMd: PropTypes.string,
    fontStyleMobileLg: PropTypes.string,
    fontStylePhabletSm: PropTypes.string,
    fontStylePhabletMd: PropTypes.string,
    fontStylePhabletLg: PropTypes.string,
    fontStyleTabletSm: PropTypes.string,
    fontStyleTabletMd: PropTypes.string,
    fontStyleTabletLg: PropTypes.string,
    // Breakpoint
    breakpointFontStyleMobileSm: PropTypes.string,
    breakpointFontStyleMobileMd: PropTypes.string,
    breakpointFontStyleMobileLg: PropTypes.string,
    breakpointFontStylePhabletSm: PropTypes.string,
    breakpointFontStylePhabletMd: PropTypes.string,
    breakpointFontStylePhabletLg: PropTypes.string,
    breakpointFontStyleTabletSm: PropTypes.string,
    breakpointFontStyleTabletMd: PropTypes.string,
    breakpointFontStyleTabletLg: PropTypes.string,
    title: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string,
    onClick: PropTypes.any,
    inline: PropTypes.bool,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
